// Rapid Reviews "Global: custom reviews" -> horizontal slider with arrows (styles: devs.css ".rr-scroller"). Loaded on every page from theme.liquid;
// it only acts on the sections listed below.
// The app renders ul.r_items_list asynchronously, so we watch the section and wire up once it has items.
(function () {
  // JSON-template sections render as #shopify-section-template--<id>__<section>, so match on the suffix.
  var SECTION_SELECTORS = ['[id$="__1790194061a2e123c0"]', ".rr-scroller-section"]; // page.conceal-protect: Global: custom reviews
  var TRACK_SELECTOR = "ul.r_items_list, .r_items_list ul";
  // Image carousel sections that should line up with (and scroll together with) the reviews right below them.
  var CAROUSEL_SELECTOR = '[id$="__image_carousel_qVtD6K"], .rr-align-carousel';
  var MARQUEE_SPEED = 60; // px per second: the aligned rows glide continuously at about the reference page's rate
  var CHEVRON = {
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.01 113.01" aria-hidden="true"><polygon points="30.5 0 38.01 4.05 9.7 56.51 38.01 108.96 30.5 113.01 0 56.51 30.5 0"></polygon></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.01 113.01" aria-hidden="true"><polygon points="7.51 0 0 4.05 28.31 56.51 0 108.96 7.51 113.01 38.01 56.51 7.51 0"></polygon></svg>'
  };

  function makeArrow(dir, label) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "rr-scroller__arrow rr-scroller__arrow--" + dir;
    btn.setAttribute("aria-label", label);
    btn.innerHTML = CHEVRON[dir];
    return btn;
  }

  function setup(track) {
    var wrapper = track.parentElement;
    if (!wrapper || !track.children.length || track.classList.contains("rr-scroller__track")) return false;

    track.classList.add("rr-scroller__track");
    wrapper.classList.add("rr-scroller");
    var prev = makeArrow("prev", "Previous reviews");
    var next = makeArrow("next", "Next reviews");
    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    function step() {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    }

    function update() {
      if (loop) return; // an endless loop has no arrows to update
      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    var loop = null;
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });

    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    });
    window.addEventListener("resize", update);
    new MutationObserver(function () { update(); refreshReadMore(); }).observe(track, { childList: true }); // "load more" appends items
    update();
    var carousel = alignCarousel(track);
    if (carousel) loop = startLoop(track, carousel.container, carousel.list, refreshReadMore);
    if (loop) { // continuous motion needs no arrows, and their hit areas would sit over the text
      prev.remove();
      next.remove();
      wrapper.classList.add("rr-scroller--loop");
    }
    update();

    // Bodies are clamped to 4 lines in CSS; give the cards that overflow a Read more / Read less toggle.
    function refreshReadMore() {
      Array.prototype.forEach.call(track.children, function (li) {
        var body = li.querySelector(".r_body > div:first-child");
        if (!body) return;
        var btn = li.querySelector(".rr-read-more");
        var clamped = li.classList.contains("rr-expanded") || body.scrollHeight > body.clientHeight + 1;
        if (!btn) {
          if (!clamped) return;
          btn = document.createElement("button");
          btn.type = "button";
          btn.className = "rr-read-more";
          btn.textContent = "Read more";
          btn.addEventListener("click", function () {
            var open = li.classList.toggle("rr-expanded");
            btn.textContent = open ? "Read less" : "Read more";
            update();
          });
          body.parentElement.appendChild(btn);
        }
        btn.hidden = !clamped;
      });
    }
    refreshReadMore();
    window.addEventListener("resize", refreshReadMore);
    return true;
  }

  // Give the before/after carousel directly above the reviews the same card width, gap and left edge, and
  // mirror scrolling between the two so each image stays above its review.
  function alignCarousel(track) {
    var section = track.closest(".shopify-section");
    var carouselSection = section && section.previousElementSibling;
    if (!carouselSection || !carouselSection.matches(CAROUSEL_SELECTOR)) return;
    var container = carouselSection.querySelector(".image-carousel__container");
    if (!container) return;

    function measure() {
      var card = track.children[0];
      if (!card) return;
      var trackStyle = getComputedStyle(track);
      var contentLeft = track.getBoundingClientRect().left + (parseFloat(trackStyle.paddingLeft) || 0);
      var sectionRect = carouselSection.getBoundingClientRect();
      [carouselSection, section].forEach(function (el) {
        el.style.setProperty("--rr-left", Math.max(0, Math.round(contentLeft - sectionRect.left)) + "px");
        el.style.setProperty("--rr-card", card.getBoundingClientRect().width + "px");
        el.style.setProperty("--rr-gap", (parseFloat(trackStyle.columnGap) || 0) + "px");
      });
      carouselSection.classList.add("rr-aligned");
    }

    var lock = null;
    function mirror(from, to) {
      return function () {
        if (lock === to) return;
        lock = from;
        to.scrollTo({ left: from.scrollLeft, behavior: "instant" });
        requestAnimationFrame(function () { lock = null; });
      };
    }

    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("swwc", measure); // the app re-classes its widget (rri/rrm) on resize
    track.addEventListener("scroll", mirror(track, container));
    container.addEventListener("scroll", mirror(container, track));
    return { container: container, list: container.querySelector(".image-carousel__list") || container.firstElementChild };
  }

  // Continuous auto-scroll of the aligned rows, looping seamlessly like the reference page. The image row is
  // first matched to the review count (extra images dropped, images repeated if there are fewer), then both
  // rows get a copy of their cards before and after the originals so the scroll position can wrap invisibly
  // in either direction. Pauses on hover, touch and drag, idles off-screen, and is skipped for reduced motion.
  function startLoop(track, container, list, refreshReadMore) {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
    var originals = Array.prototype.slice.call(track.children);
    var images = Array.prototype.slice.call(list.children);
    var count = originals.length;
    if (count < 2 || !images.length) return null;

    var imageItems = [];
    list.innerHTML = "";
    for (var i = 0; i < count; i++) {
      var item = images[i % images.length].cloneNode(true);
      list.appendChild(item);
      imageItems.push(item);
    }
    function addClones(parent, items, atStart) {
      (atStart ? items.slice().reverse() : items).forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute("data-rr-clone", "");
        clone.classList.remove("rr-expanded");
        var btn = clone.querySelector(".rr-read-more");
        if (btn) btn.remove();
        if (atStart) parent.insertBefore(clone, parent.firstChild); else parent.appendChild(clone);
      });
    }
    addClones(track, originals, true); addClones(track, originals, false);
    addClones(list, imageItems, true); addClones(list, imageItems, false);
    if (refreshReadMore) refreshReadMore();

    [track, container].forEach(function (el) { el.style.scrollSnapType = "none"; el.style.scrollBehavior = "auto"; });

    function cycle() { return track.children[count].offsetLeft - track.children[0].offsetLeft; } // one full set of cards
    function wrap(x) { var c = cycle(); if (x >= 2 * c) x -= c; else if (x < c) x += c; return x; }
    function normalize(el) { var x = wrap(el.scrollLeft); if (x !== el.scrollLeft) el.scrollLeft = x; }

    var pos = cycle(); // start on the originals; a full copy sits before them so dragging backwards works too
    track.scrollLeft = pos; container.scrollLeft = pos;

    var paused = false, visible = false, last = null, resumeTimer = null;
    function frame(now) {
      if (last === null) last = now;
      var dt = Math.min(now - last, 50); // ignore long gaps (hidden tab) instead of jumping
      last = now;
      if (!paused && visible) {
        pos = wrap(pos + MARQUEE_SPEED * dt / 1000);
        track.scrollLeft = pos; container.scrollLeft = pos;
      }
      requestAnimationFrame(frame);
    }
    function pause() { clearTimeout(resumeTimer); paused = true; }
    function resume() { normalize(track); container.scrollLeft = track.scrollLeft; pos = track.scrollLeft; paused = false; }
    function resumeLater(ms) { clearTimeout(resumeTimer); resumeTimer = setTimeout(resume, ms); }
    [track.parentElement, container].forEach(function (el) {
      el.addEventListener("mouseenter", pause);
      el.addEventListener("mouseleave", function () { resumeLater(300); });
      el.addEventListener("touchstart", pause, { passive: true });
      el.addEventListener("touchend", function () { resumeLater(1500); }, { passive: true });
    });
    [track, container].forEach(function (el) {
      el.addEventListener("scroll", function () { // user-driven scrolling: keep the position inside the loop range
        if (paused && !container.classList.contains("is-dragging")) normalize(el);
      });
    });
    // Run as soon as the section above the images (heading + copy), the images or the reviews reach the
    // viewport (100px early), and keep running while any of them is in view.
    var reviewsSection = track.closest(".shopify-section") || track;
    var imagesSection = container.closest(".shopify-section") || container;
    var targets = [imagesSection.previousElementSibling, imagesSection, reviewsSection].filter(Boolean);
    var inView = targets.map(function () { return false; });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { inView[targets.indexOf(entry.target)] = entry.isIntersecting; });
      visible = inView.some(Boolean);
    }, { threshold: 0, rootMargin: "100px 0px" });
    targets.forEach(function (t) { observer.observe(t); });
    requestAnimationFrame(frame);
    return true;
  }

  function watch(root) {
    var track = root.querySelector(TRACK_SELECTOR);
    if (track && setup(track)) return;
    var observer = new MutationObserver(function () {
      var track = root.querySelector(TRACK_SELECTOR);
      if (track && setup(track)) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll(SECTION_SELECTORS.join(",")).forEach(watch);
  }

  boot();
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector) watch(e.target);
  });
})();
